"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.infer = infer;
const zod_1 = require("zod");
function infer(dataSchema) {
  return zod_1.z.object({
    status: zod_1.z.literal('ok'),
    data: dataSchema
  }).or(zod_1.z.object({
    status: zod_1.z.literal('error'),
    errorCode: zod_1.z.number(),
    errorMessage: zod_1.z.string()
  }));
}
